export { CV } from "./CV";
export * from "./CV.common.scss";
